import { useLayer } from '@coursera-web/statsig';

import { useLocation } from 'js/lib/useRouter';

import {
  type TrendingNowPillVariant,
  isTrendingNowPillSlug,
} from 'bundles/product-card/components/utils/trendingNowPillUtils';
import { isEnterprisePathname } from 'bundles/product-card/utils/isEnterprisePathname';

export type { TrendingNowPillVariant };

/**
 * Resolves the "Trending right now" pill variant for a product card. Only evaluates the Statsig layer
 * once the card is confirmed eligible (qualifying slug, consumer page), so ineligible renders
 * don't log a misleading exposure.
 */
export const useTrendingNowPillVariant = (slug?: string): TrendingNowPillVariant => {
  const location = useLocation();
  const layer = useLayer('product-card-trending-now-pill-layer');

  const isEligible = !!slug && isTrendingNowPillSlug(slug) && !isEnterprisePathname(location.pathname);

  if (!isEligible) {
    return 'none';
  }

  const variant = layer.get('New pill tag', 'none');
  return variant === 'gradient-background' || variant === 'solid-background' ? variant : 'none';
};
